<form [formGroup]="projectDataForm" class="d-flex flex-column space-y-4">
    <section-info></section-info>
    
    <div class="grid grid-cols-4 space-x-4">
        <kendo-formfield class="col-span-3">
            <kendo-label class="form-label" #lblTitle [for]="title" text="{{'project-data.projectTitle' | translate}} *" [infotooltip]="'projektdaten.titel'"></kendo-label>
            <kendo-textbox id="title" #title formControlName="title" showSuccessIcon="initial" showErrorIcon="initial" [appinfotext]="'projektdaten.titel'" preventEmptyFormatter [maxlength]=200></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield class="col-span-1">
            <kendo-label class="form-label" #lblKurztitel [for]="kurzTitel" text="{{'project-data.shortTitle' | translate}}" [infotooltip]="'projektdaten.kurztitel'"></kendo-label>
            <kendo-textbox id="kurzTitel" #kurzTitel formControlName="kurzTitel" showSuccessIcon="initial" showErrorIcon="initial" [appinfotext]="'projektdaten.kurztitel'" preventEmptyFormatter [maxlength]=100></kendo-textbox>
        </kendo-formfield>
    </div>
    
    <div class="grid grid-cols-4">
        <div class="col-span-3 grid grid-cols-2 space-x-4">
            <kendo-formfield class="col-span-1">
                <kendo-label class="form-label" [for]="projektStart" text="{{'project-data.plannedProjectStart' | translate }} *" [infotooltip]="'projektdaten.projektstart'"></kendo-label>
                <kendo-datepicker
                    #projektStart
                    (valueChange)="onProjektStartChange($event)"
                    formControlName="projektStart"
                    [appinfotext]="'projektdaten.projektstart'"
                    [format]="dateFormat"
                    [incompleteDateValidation]="true"></kendo-datepicker>
            </kendo-formfield>
            
            <kendo-formfield class="col-span-1" [ngClass]="{ 'opacity-50': !projektStart.value }">
                <kendo-label class="form-label" [for]="projektEnd" text="{{'project-data.plannedProjectEnd' |translate}} *" [infotooltip]="'projektdaten.projektende'"></kendo-label>
                <kendo-datepicker
                    #projektEnd
                    formControlName="projektEnd"
                    [min]="projektStart.value"
                    [readonly]="!projektStart.value"
                    [disabled]="!projektStart.value"
                    [appinfotext]="'projektdaten.projektende'"
                    [incompleteDateValidation]="true"
                    [format]="dateFormat"></kendo-datepicker>

                <kendo-formerror *ngIf="endBeforeStartErrorMessage">{{ endBeforeStartErrorMessage }}</kendo-formerror>
            </kendo-formfield>
        </div>
    </div>
    
    <kendo-formfield class="mt-8">
        <kendo-label class="form-label" [for]="projektbeschreibung" text="{{'project-data.projectDescription'|translate}} *" [infotooltip]="'projektdaten.projektbeschreibung'"></kendo-label>
        <ckeditor #projektbeschreibung formControlName="projektbeschreibung" [editor]="Editor" (ready)="initCKEditor($event, 'word-count-projektbeschreibung')" data="" [config]="editorConfig" [appinfotext]="'projektdaten.projektbeschreibung'"></ckeditor>
        <div id="word-count-projektbeschreibung"></div>
    </kendo-formfield>
    
    <kendo-formfield>
        <kendo-label class="form-label" [for]="projektbeteiligte" text="{{'project-data.projectParticipants' | translate }} *" [infotooltip]="'projektdaten.projektbeteiligte'"></kendo-label>
        <ckeditor id="projektbeteiligte" #projektbeteiligte formControlName="projektbeteiligte" [editor]="Editor" (ready)="initCKEditor($event, 'word-count-projektbeteiligte')" data="" [config]="editorConfig" [appinfotext]="'projektdaten.projektbeteiligte'"></ckeditor>            
        <div id="word-count-projektbeteiligte"></div>
    </kendo-formfield>
    
    <div *ngIf="aiResponseLoading" id="ai-vorabcheck-loading-div" class="mt-8" style="border: 1px solid #efefef; border-radius: 4px; padding: 1rem 1.5rem; display: flex; align-items: center;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="height: 1.5rem; width: 1.5rem;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
        </svg>
        
        <span class="ml-2 form-label" translate>
            description.ai.check.loading
        </span>
    </div>

    <div *ngIf="aiResponseFinished" class="mt-8" style="border: 1px solid #efefef; border-radius: 4px;">
        <div style="border-bottom: 1px solid #efefef; padding: 0.75rem 1.5rem; display: flex; align-items: center;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="height: 1.5rem; width: 1.5rem;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
            </svg>
            
            <span class="ml-2 form-label" translate>
                description.ai.check.result
            </span>
        </div>

        <div style="padding: 1rem 1.5rem;" [innerHTML]="aiResponse" id="ai-vorabcheck-response-div"></div>
    </div>
</form>